import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import StarIcon from "@mui/icons-material/Star";
import "../../components/popularProducts/popularproducts.css";
import { baseURL } from "../../constants/url";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
 import Swal from "sweetalert2"; 
 import { CartContext } from "../../context/CartContext";
 import { WishlistContext } from "../../context/WishlistContext";

const DailyBestSellsSlider = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const {cartItems, fetchCartCount } = useContext(CartContext);
  const { fetchWishlistCount } = useContext(WishlistContext);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

   
const addToCart = async (variant) => {
  if (variant.stock === 0) return;

  const token = localStorage.getItem("authToken");

  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Login Required",
      text: "Please login first",
      confirmButtonText: "Go to Login",
    }).then(() => {
      navigate("/login");
    });
    return;
  }
 

  const alreadyInCart = cartItems?.some(item => item.variant_id === variant);
  if (alreadyInCart) {
    Swal.fire({
      icon: "info",
      title: "Already in Cart",
      text: "This product is already in your cart.",
      timer: 1500,
      showConfirmButton: false,
    });
    return;
  }

  try {
    const res = await axios.post(
      `${baseURL}common/cart/add/`,
      {
        variant_id: variant,
        quantity: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Added to Cart!",
      text: "The product has been added to your cart.",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchCartCount(); // Update cart count
  } catch (error) {
    console.error("Cart Error:", error?.response?.data || error.message);
    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Failed to add product to cart.",
    });
  }
};

  const toggleWishlist = async (variantId) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Please Login",
        text: "Please log in to use wishlist.",
        confirmButtonText: "Go to Login",
      }).then(() => {
        navigate("/login");
      });
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}common/wishlist_toggle/${variantId}/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const isWishlisted =
        response?.data?.message?.toLowerCase().includes("added");

      Swal.fire({
        icon: isWishlisted ? "success" : "info",
        title: isWishlisted
          ? "Added to Wishlist"
          : "Removed from Wishlist",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
      });

      // Update local state
      setProducts((prevProducts) =>
        prevProducts.map((product) => ({
          ...product,
          variants: product.variants.map((variant) =>
            variant.id === variantId
              ? { ...variant, is_wishlisted: isWishlisted }
              : variant
          ),
        }))
      );

      fetchWishlistCount();
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: "Please try again later.",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${baseURL}common/featured_products/`);
        const data = res.data;
        console.log("API Response:", data);
        
        if (Array.isArray(data)) {
          const filtered = data.filter((item) => item.big_deal === true);
          console.log("Jogendra Singh test Filtered Products:", filtered);
          setProducts(filtered);
        } else {
          console.error("Unexpected data format. Expected array, got:", typeof data);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    console.log("Rendered products:", products);
  }, [products]);

  return (
    <div className="home_banner_old daily_best_slider">
      {products.length === 0 ? (
        <div className="watermark-container">
          <p className="watermark-text">No Daily Best Deals Available</p>
        </div>
      ) : (
        <Slider {...settings} className="homeSlider">
          {/* {products.map((product) => ( */}
           {products.length > 0 ? (
            products.map((product) => {
            const variant = product.variants?.[0];
            if (!variant) return null;
            const isOutOfStock = variant.stock === 0;
            const imagePath = variant.images?.[0]?.image;
            const isWishlisted = variant.is_wishlisted;

          // {products?.length > 0 ? (
          // products.map((product) => {
          //   const variant = product.variants?.[0];
          //   const imagePath = variant?.images?.[0]?.image;
             
            return (
            <div className="item" key={product.id}>
              <div className="popular_products_grid">
                <div className="popular_products_grid_in">
                  <div className="products_head d_flex align_center justify_sp_between">
                    <span className="sale_type font_size14">Hot</span>
                    <div className="whislist_icon_box">
                     <button
                          onClick={() => toggleWishlist(variant.id)}
                          className="wishlist-btn"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          {variant.is_wishlisted ? (
                            <FavoriteIcon style={{ color: "red" }} />
                          ) : (
                            <FavoriteBorderIcon style={{ color: "green" }} />
                          )}
                        </button>
                     {/* <button
                           onClick={() => addToCart(variant.id)}
                            className="add_to_cart_icons_N wishlist-btn font_size14"
                            style={{ background: "transparent", border: "none", cursor: "pointer", }}
                          >
                            <AddShoppingCartIcon style={{ color: "green" }} />
                          </button> */}
                           <button
                            onClick={() => addToCart(variant.id)}
                            disabled={isOutOfStock}
                            className="add_to_cart_icons_N mt_5 wishlist-btn font_size14"
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.4 : 1,
                              pointerEvents: isOutOfStock ? "none" : "auto",
                            }}
                          >
                            <AddShoppingCartIcon style={{ color: "green" }} />
                          </button>
                          </div>
                       </div>
                  <div className={`products_details ${isOutOfStock ? "out-of-stock" : ""}`}>
                    <div className="products_img d_flex align_center">
                      <Link to={`/product-details/${product.id}`}>
                        <img
                          src={imagePath || "/placeholder.png"}
                          alt={product.name}
                          className="img-fluid"
                          style={{ height: "200px", objectFit: "contain" }}
                        />
                      </Link>
                        {isOutOfStock && (
                        <span className="out_of_stock_badge">
                          Out of Stock
                        </span>
                      )}
                    </div>

                    <div className="products_info">
                      <div className="products_name mb_10 mt_5">
                        <Link to={`/product-details/${product.id}`}>
                          {product.name}
                        </Link>
                      </div>

                      <div className="pro_price mt_10 d_flex gap_10 align_center">
                        <h6>₹{variant?.final_price}/</h6>
                        <h6 className="price_cut">
                          <s>₹{variant?.price}</s>/
                        </h6>
                        <h6 className="common_color">
                          {variant?.discount_percent}% Off
                        </h6>
                      </div>

                      <div className="rating_part d_flex gap_5 align_center">
                        <span>{variant?.average_rating || "0.0"}</span>
                        <StarIcon />
                      </div>
                    </div>
                  </div>

                  {/* <div className="products_footer d_flex align_center justify_sp_center">
                    <div className="mb_20">
                      <Link
                        to={`/product-details/${product.id}`}
                        className="buy_btn font_size14"
                      >
                        Buy Now
                      </Link>
                    </div> */}
                     <div className="products_footer d_flex align_center justify_sp_center">
                          <Link
                            to={isOutOfStock ? "#" : `/product-details/${product.id}`}
                            className={`buy_btn font_size14 ${isOutOfStock ? "disabled-link" : ""}`}
                            onClick={(e) => {
                              if (isOutOfStock) {
                                e.preventDefault(); // stop navigation
                              }
                            }}
                            style={{
                              background: isOutOfStock ? "#f38c55" : "",
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              pointerEvents: isOutOfStock ? "none" : "auto",
                            }}
                          >
                            {isOutOfStock ? "Out of Stock" : "Buy Now"}
                          </Link> 
                  </div>
                </div>
              </div>
            </div>
          )})
        ) : (
          <p>No Products Available</p>
        )}
        </Slider>
      )}
    </div>
  );
};

export default DailyBestSellsSlider;
